import React from 'react';
import PropTypes from 'prop-types';
import { Marker, InfoWindow } from 'components/maps';
import workingTruckMarker from 'components/shipment/maps/markers/working-truck.png';
import activeTruckMarker from 'components/shipment/maps/markers/truck.png';
import DriverJobsPopover from 'components/modules/shipments/tracking/DriverJobsPopover';

const DriverMarker = ({
  id,
  position,
  isOpen,
  driver,
  phone,
  jobs,
  hasActiveJobs,
  onMarkerClick,
  onCloseInfoWindow,
  onOpenShipment,
}) => {
  const iconUrl = hasActiveJobs ? activeTruckMarker : workingTruckMarker;

  return (
    <>
      <Marker
        position={position}
        icon={iconUrl}
        onClick={() => onMarkerClick(id)}
      />
      {isOpen && (
        <InfoWindow position={position} onClose={() => onCloseInfoWindow(id)}>
          <DriverJobsPopover
            hasActiveJobs={hasActiveJobs}
            jobs={jobs}
            driver={driver}
            phone={phone}
            onOpenShipment={onOpenShipment}
          />
        </InfoWindow>
      )}
    </>
  );
};

DriverMarker.propTypes = {
  id: PropTypes.string.isRequired,
  position: PropTypes.object.isRequired,
  isOpen: PropTypes.bool,
  driver: PropTypes.shape({
    fullName: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  phone: PropTypes.string,
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  onMarkerClick: PropTypes.func.isRequired,
  onCloseInfoWindow: PropTypes.func.isRequired,
  onOpenShipment: PropTypes.func,
  hasActiveJobs: PropTypes.bool,
};

DriverMarker.defaultProps = {
  phone: null,
  isOpen: false,
  onOpenShipment: () => {},
};

export default DriverMarker;
